export interface SalesInvoiceHeaderDeliveryItem {
  id: string;
  salesInvoiceHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
}
